module.exports = __webpack_public_path__ + "static/media/award.149f7516.svg";